import COMPONENT_CLASS_NAME from './Search.constant';
/**
 * Get component class name
 *
 * @param isActiveStatus
 * @param loading
 */
export var getComponentClassName = function (isActiveStatus, loading) {
    var className = COMPONENT_CLASS_NAME;
    if (isActiveStatus) {
        className = COMPONENT_CLASS_NAME + " search-active";
    }
    if (loading) {
        className = className + " loading";
    }
    return className;
};
//# sourceMappingURL=Search.functions.js.map